import {
  FETCH_LOCATION_NAMES_REQUEST,
  FETCH_LOCATION_NAMES_SUCCESS,
  FETCH_LOCATION_NAMES_FAILURE,
  SAVE_LOCATION_NAME_REQUEST,
  SAVE_LOCATION_NAME_SUCCESS,
  SAVE_LOCATION_NAME_FAILURE,
  DELETE_LOCATION_NAME_REQUEST,
  DELETE_LOCATION_NAME_SUCCESS,
  DELETE_LOCATION_NAME_FAILURE,
} from './types';

const INITIAL_STATE = {
  locationNameList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LOCATION_NAMES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_LOCATION_NAMES_SUCCESS:
      return {
        ...state,
        loading: false,
        locationNameList: action.payload,
      };

    case FETCH_LOCATION_NAMES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        locationNameList: [],
      };
    case SAVE_LOCATION_NAME_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_LOCATION_NAME_SUCCESS:
      return {
        ...state,
      };

    case SAVE_LOCATION_NAME_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_LOCATION_NAME_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_LOCATION_NAME_SUCCESS:
      return {
        ...state,
      };

    case DELETE_LOCATION_NAME_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
